import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, merge, Subject, Subscription, switchMap, takeUntil, timeout, timer } from 'rxjs';
import { GlobalService } from '../global-helper';
import { GatewayConnectionService } from '../../apiHandler/gateway-connection/gateway-connection.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class IdleTimerService implements OnDestroy {

  private idleTimeout = 1800000;
  private idle$ = new Subject<void>();
  private reset$ = new Subject<void>();
  private eventsSub?: Subscription;
  private timerSub?: Subscription;

  constructor(private global: GlobalService, private apiGwConnection: GatewayConnectionService, private router: Router) {}

  ngOnDestroy() {
    this.stopWatching();
  }

  public startWatching(timeoutMs: number = this.idleTimeout) {
    this.idleTimeout = timeoutMs;

    const activity$ = merge(fromEvent(window, 'mousemove'),fromEvent(window, 'mousedown'),fromEvent(window, 'keydown'),fromEvent(window, 'scroll'),fromEvent(window, 'touchstart'),fromEvent(window, 'click'));

    this.eventsSub = activity$.subscribe(() => this.resetTimer());
    
    this.startTimer();
  }

  private startTimer() {
    this.timerSub?.unsubscribe();

    this.timerSub = this.reset$.pipe(switchMap(() => timer(this.idleTimeout)), takeUntil(this.idle$)).subscribe(() => this.handleIdle());
    this.resetTimer();
  }

  public resetTimer() {
    this.reset$.next();
  }

  private handleIdle() {
    this.idle$.next();
    this.stopWatching();
    this.switchMachine();
  }

  private switchMachine(){
    this.apiGwConnection.disconnectFromGateway().subscribe();
    this.global.machineNumber.next({ number: '', id: '', series: ''});
    this.global.machineInfos.next({line: '', name:'', engine: ''});
    this.global.variables.next({ connected: false});
    this.global.swVersion.next({loaded: false, versions: []});
    this.global.comission.next({enabled: false});
    this.router.navigateByUrl("");
  }

  public onIdle() {
    return this.idle$.asObservable();
  }

  public stopWatching() {
    this.eventsSub?.unsubscribe();
    this.timerSub?.unsubscribe();
  }
}
